import { axiosGet, axiosPost } from '@/api/AxiosApi';

export type boardListProps = {
  board_type?: 'notice' | 'event';
  search_lang?: 'KO' | 'EN';
};
export type resNoticeListProps = {
  board_id: string;
  seq: string;
  board_type: string;
  title: string;
  post: any; // html 테그
  lang: string;
  opend_yn: string;
  popup_yn: string;
  admin_id: string;
  start_dt: string | null;
  end_dt: string | null;
  reg_dt: string;
  mod_dt: string;
  event_status: string | null;
  asset_url: string | null;
};
export const boardList = async ({ board_type = 'notice', search_lang = 'KO' }: boardListProps) => {
  const payload = {
    path: '/v1/board/list',
    body: {
      board_type,
      list_size: 100,
      page_num: 1,
      search_lang,
      search_opend_yn: 'Y',
    },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
export type boardDetailProps = {
  board_type: string;
  board_id: string;
};
export type resBoardDetail = {
  board_id: string;
  seq: number;
  board_type: string;
  title: string;
  post: any;
  lang: string;
  opend_yn: string;
  popup_yn: string;
  admin_id: string;
  start_dt: string | null;
  end_dt: string | null;
  reg_dt: string;
  mod_dt: string;
  event_status: string | null;
};
export const boardDetail = async ({ board_type = 'notice', board_id }: boardDetailProps) => {
  const payload = {
    path: '/v1/board/view',
    body: {
      board_type,
      board_id,
    },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

export const boardView = async ({ board_id }: { board_id: string }) => {
  const payload = {
    path: `/v1/board/view/${board_id}`,
  };
  const { data: re } = await axiosGet(payload);
  return re;
};

export type fileListProps = {
  asset_id: string;
  destination: string;
  encoding: string;
  filename: string;
  minetype: string;
  originalname: string;
  path: string;
  reg_dttm: string;
  seq: string;
  size: number;
  url: string;
};

export type resBoardPopListProps = {
  admin_id: string;
  asset_url: string | null;
  board_id: string;
  board_type: 'event' | 'notice';
  end_dt: string;
  lang: 'KO' | 'EN';
  opend_yn: 'Y' | 'N';
  popup_yn: 'Y' | 'N';
  post: any;
  reg_dt: string;
  seq: number;
  start_dt: string;
  title: string;
};
export const boardPopList = async (type: string = 'notice') => {
  const payload = {
    path: '/v1/board/poplist',
    body: {
      board_type: type,
      lang: 'KO',
    },
  };

  const { data: re } = await axiosPost(payload);
  return re;
};
